<template>
  <div class="request-form">
    <form class="form" :action="endpoint" accept-charset="UTF-8" method="get" @submit.prevent="submit">
      <ul v-if="errors.length > 0" class="form-error">
        <li v-for="(error, index) in errors" :key="index" class="form-error-item">
         {{error}}
        </li>
      </ul>
      <div class="age-area" v-if="isAgeShow && isChecked">
        <p class="title">職業に合わせた国・プランで資料をもらう！</p>
        <div class="buttons">
          <button class="button" @click="checkedItems('4')">社会人向け</button>
          <button class="button" @click="checkedItems('3')">大学生向け</button>
          <button class="button" @click="checkedItems('2')">高校生向け</button>
        </div>
      </div>

      <div class="selected-agents" v-if="!isEmptyAgent">
        <p class="header">選択中のエージェント</p>
        <p class="agent-name">{{ agent.name }}</p>
      </div>

      <p class="selectedMessage" v-if="!isChecked">{{ selectedMessage }}</p>

      <!-- MEMO: インライン要素の隙間を埋めるためにコメントアウトを挟んでいます -->
      <!-- 参考: https://www.tsubasa-note.blog/entry/inline-element-gap-fixed/ -->
      <p class="lead-text" v-if="isExpectLeadTextParams">
        <span v-if="isExpectRegion">
          <span class="name">{{ regionName }}</span>を選んだ<!--
    --></span><!--
    --><span v-if="isExpectAge">
          <span class="name">{{ ageName }}</span>の<!--
    --></span><!--
     -->あなたにぴったりな
        <br>
        パンフレットを無料でお届け！
      </p>
      <p class="guide" v-else>希望条件を選択してください</p>

      <checklist v-model="checkedCountryIds" inputName="form_country_id[]" :items="countries" :required="true">
        <template #legend>気になる国を選択（何ヶ国でもOK）</template>
      </checklist>

      <checklist v-model="checkedPurposeIds" inputName="form_purpose_id[]" :items="purposes" :required="true">
        <template #legend>興味があるプランを選択</template>
      </checklist>

      <selection v-if="ages.length > 0" v-model="selectedAgeId" inputName="form_age_id[]" :items="ages"
                 valueProp="id" :required="true"
                 @change="selectedAgeId = Number.parseInt($event) || null">
        <template #legend>現在の職業を選択</template>
      </selection>

      <button class="next step1" type="submit">次へ進む</button>
    </form>

    <div class="agent-modal" v-if="considerings.countryId || considerings.purposeId">
      <div class="agent-modal-background"></div>

      <div class="agent-modal-content">
        <div class="message">
          <!-- 改行都合で文言出し分け-->
          <p class="text pc-only">この項目のチェックを外すと、もらえるパンフレットから</p>
          <p class="text sp-only">この項目のチェックを外すと、</p>
          <p class="text sp-only">もらえるパンフレットから</p>
          <p class="agent-name">{{ agent.name }}</p>
          <p class="text">が外れますがよろしいですか？</p>

          <hr>

          <p class="hint">★ ヒント</p>
          <p class="text">選んだエージェントがパンフレットから外れてしまう場合は、<strong>「国」</strong><strong>「目的」</strong>の候補を増やしてみましょう！</p>

        </div>

        <img class="illustration" src="../assets/images/reserve/agents/woman.svg">

        <div class="action">
          <button class="choice" @click="undoCountryPurpose">キャンセルする</button>
          <button class="choice" @click="clearConsiderings">チェックを外す</button>
        </div>

        <button class="close" @click="undoCountryPurpose"></button>
      </div>
    </div>

    <div class="agent-modal" v-if="considerings.ageId">
      <div class="agent-modal-background"></div>

      <div class="agent-modal-content">
        <div class="message">
          <!-- 改行都合で文言出し分け-->
          <p class="text pc-only">{{ consideringAge.label }}&nbsp;を選んだため、もらえるパンフレットから</p>
          <p class="text sp-only">{{ consideringAge.label }}&nbsp;を選んだため、</p>
          <p class="text sp-only">もらえるパンフレットから</p>
          <p class="agent-name">{{ agent.name }}</p>
          <p class="text">が外れました。</p>

          <hr>

          <p class="hint">★そのまま入力で、条件に沿ったパンフレットが届きます</p>
          <p class="text">現在、選択している国と目的にあったパンフレットを無料でお届け！</p>
        </div>

        <img class="illustration" src="../assets/images/reserve/agents/woman.svg">

        <div class="action">
          <button class="choice" @click="submitByAge">そのまま入力を続ける</button>
        </div>

        <button class="close" @click="clearConsiderings"></button>
      </div>
    </div>
  </div>
</template>

<script>
import Checklist from '@/form/checklist'
import Selection from '@/form/selection'
import axios from 'axios'
import { convertFormDataForGet, pageToTop } from '@/form/modules/form'

export default {
  components: {
    Checklist,
    Selection
  },

  props: {
    endpoint: {
      type: String,
      required: true
    },
    checked_country_ids: {
      type: Array,
      required: true
    },
    checked_purpose_ids: {
      type: Array,
      required: true
    },
    selected_agent_id: {
      type: Number,
      required: false
    },
    age: {
      type: String,
      required: false
    },
    region: {
      type: String,
      required: false
    }
  },

  data: function () {
    return {
      countries: [],
      form_country_ids: [],
      purposes: [],
      form_purpose_ids: [],
      isChecked: true,
      ages: [],
      errors: [],
      checkedCountryIds: Array.from(this.checked_country_ids),
      checkedPurposeIds: Array.from(this.checked_purpose_ids),
      selectedAgeId: null,
      agent: {},
      agentConditions: {
        countryPurposeConditions: [],
        ageConditions: []
      },
      considerings: {
        countryId: null,
        purposeId: null,
        ageId: null
      }
    }
  },

  computed: {
    isEmptyAgent: function () {
      return Object.keys(this.agent).length === 0
    },

    isAgeShow: function () {
      return (this.errors.join(',')).length > 16
    },

    consideringAge: function () {
      return this.ages.find(age => age.id === this.considerings.ageId)
    },

    isExpectAge () {
      return ['student', 'adult'].includes(this.age)
    },

    isExpectRegion () {
      return ['english', 'europe', 'asia'].includes(this.region)
    },

    isExpectLeadTextParams () {
      return this.isExpectAge || this.isExpectRegion
    },

    ageName () {
      switch (this.age) {
        case 'student':
          return '学生'
        case 'adult':
          return '社会人'
        default:
          return null
      }
    },

    selectedMessage () {
      const selectedIndex = document.querySelector('select').selectedIndex
      const ageName = document.querySelector('select').options[selectedIndex].text
      return ageName.concat('向け 国・プランが選択されました')
    },

    regionName () {
      switch (this.region) {
        case 'english':
          return '英語圏'
        case 'europe':
          return 'ヨーロッパ'
        case 'asia':
          return 'アジア'
        default:
          return null
      }
    }
  },

  watch: {
    checkedCountryIds: function (newCountryIds, oldCountryIds) {
      // チェックをつけたとき
      if (oldCountryIds.length <= newCountryIds.length) {
        return
      }

      if (this.matchAgentCondition(newCountryIds, this.checkedPurposeIds)) {
        return
      }

      const uncheckedId = oldCountryIds.find(id => !newCountryIds.includes(id))

      // 外した国が条件に絡まないときは何もしない
      const includeCondition = this.agentConditions.countryPurposeConditions
        .map(item => item.form_country_id)
        .includes(uncheckedId)
      if (!includeCondition) {
        return
      }

      this.considerings.countryId = uncheckedId
    },

    checkedPurposeIds: function (newPurposeIds, oldPurposeIds) {
      // チェックをつけたとき
      if (oldPurposeIds.length <= newPurposeIds.length) {
        return
      }

      if (this.matchAgentCondition(this.checkedCountryIds, newPurposeIds)) {
        return
      }

      const uncheckedId = oldPurposeIds.find(id => !newPurposeIds.includes(id))

      // 外した目的が条件に絡まないときは何もしない
      const includeCondition = this.agentConditions.countryPurposeConditions
        .map(item => item.form_purpose_id)
        .includes(uncheckedId)
      if (!includeCondition) {
        return
      }

      this.considerings.purposeId = uncheckedId
    },

    selectedAgeId: function (newAgeId, oldAgeId) {
      // 国、目的条件にあってなかったら何もしない
      if (!this.matchAgentCondition(this.checkedCountryIds, this.checkedPurposeIds)) {
        return
      }

      if (this.agentConditions.ageConditions.includes(newAgeId)) {
        this.considerings.ageId = null
      } else {
        this.considerings.ageId = newAgeId
      }
    }
  },

  created: function () {
    axios.get('/reserve/agents/request.json', {
      params: {
        agent_id: this.selected_agent_id
      }
    }).then((res) => {
      const data = res.data

      this.countries = data.countries
      this.purposes = data.purposes
      this.ages = data.ages

      if (this.selected_agent_id) {
        this.agent = data.agent
        this.agentConditions.countryPurposeConditions =
          Array.from(data.agent_conditions.country_purpose_conditions)
        this.agentConditions.ageConditions =
          Array.from(data.agent_conditions.age_conditions)
      }
    })
  },

  methods: {
    submit: function (e) {
      const object = convertFormDataForGet(e)

      if (this.selected_agent_id && this.matchAgentCurrentCondition()) {
        object.agent_id = this.selected_agent_id
      }

      axios.get(this.endpoint, { params: object }).then((res) => {
        if (res.data.errors) {
          this.errors = res.data.errors
          pageToTop()
        } else {
          location.href = res.data.redirect_to
        }
      })
    },

    clearConsiderings: function () {
      this.considerings.countryId = null
      this.considerings.purposeId = null
      this.considerings.ageId = null
    },

    checkedItems: function (v) {
      // チェックした内容をclearする
      document.querySelectorAll("input[type='checkbox']:checked").forEach(e => {
        e.checked = false
      })
      // 国：アメリカ[1]・オーストラリア[2]・ニュージーランド[3]・カナダ[4]・イギリス[5]
      const countryIds = [1, 2, 3, 4, 5]
      // 目的：語学留学[1],ワーホリ[3]
      const purposeIds = [1, 3]
      if (v === '2') {
        document.querySelector('input[name="form_purpose_id[]"][value="1"]').checked = true
      } else {
        purposeIds.forEach(i => { document.querySelector('input[name="form_purpose_id[]"][value="' + i + '"]').checked = true })
      }

      countryIds.forEach(i => { document.querySelector('input[name="form_country_id[]"][value="' + i + '"]').checked = true })
      document.querySelector('select').value = v
      this.isChecked = false
      this.errors.length = 0
    },

    undoCountryPurpose: function () {
      if (this.considerings.countryId) {
        this.checkedCountryIds.push(this.considerings.countryId)
      }
      if (this.considerings.purposeId) {
        this.checkedPurposeIds.push(this.considerings.purposeId)
      }

      this.considerings.countryId = null
      this.considerings.purposeId = null
    },

    // 国・目的がエージェントの条件に含まれているか
    matchAgentCondition: function (countryIds, purposeIds) {
      return this.agentConditions.countryPurposeConditions
        .some(condition =>
          countryIds.includes(condition.form_country_id) &&
          purposeIds.includes(condition.form_purpose_id)
        )
    },

    // 現在の条件が指定のエージェントにマッチしているか
    matchAgentCurrentCondition: function () {
      return this.matchAgentCondition(this.checkedCountryIds, this.checkedPurposeIds) &&
             this.agentConditions.ageConditions.includes(this.selectedAgeId)
    },

    submitByAge: function () {
      this.clearConsiderings()
      this.$el.querySelector('[type="submit"]').click()
    }
  }
}
</script>
